module.exports = __webpack_public_path__ + "img/dxq.7dfdb64.png";